export default {
    common: {
        title: 'AI Innhold ',
        socialPlanner: 'Medie Planlegger',
        blog: 'Blogg',
        funnel: 'Forløp',
        website: 'Nettside',
        mediaLibrary: 'Mediebibliotek',
        email: 'E-post',
        words: 'Ord',
        variations: 'Varianter',
        thisIsPaidService: 'Denne funksjonen er en betalt tjeneste og vil pådra kostnader basert på ditt bruk',
        all: 'Todos',
    },
};
